import { getDecimalPlaces } from "../components/Shared/Utility";

/**
 * PDF number format using pump DecimalPlaces setting.
 * Optional second arg overrides decimal places (e.g. 0 for whole amounts).
 */
export const PrintFormateNumber = (num, decimalsOverride) => {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const decimals =
    decimalsOverride !== undefined && decimalsOverride !== null
      ? decimalsOverride
      : getDecimalPlaces();

  const fixedNum = Number(num).toFixed(decimals);
  const [intPart, decPart] = fixedNum.split(".");
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimals === 0 || decPart === undefined) {
    return formattedInt;
  }

  return `${formattedInt}.${decPart}`;
};

/** Parse API totals that may already include comma separators. */
export const parseReportAmount = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  if (typeof val === "number") return val;
  return parseFloat(String(val).replace(/,/g, "")) || 0;
};

/** Format API values that may be plain numbers or balances like "1,234 Debit". */
export const formatReportField = (val, decimalsOverride) => {
  if (val === null || val === undefined || val === "") return "—";
  const str = String(val).trim();
  const typeMatch = str.match(/\s+(Debit|Credit)$/i);
  if (typeMatch) {
    const numPart = str.slice(0, typeMatch.index).trim();
    return `${PrintFormateNumber(
      parseReportAmount(numPart),
      decimalsOverride
    )} ${typeMatch[1]}`;
  }
  return PrintFormateNumber(parseReportAmount(str), decimalsOverride);
};
